export const REFRESH_TIME = 1000 * 60 * 5;

export const WAITING_TO_MOVE = 1;
export const MOVING = 2;
export const STOPPED = 3;

export const parkColors = {"mk": "#8d93ff", "ep": "#8c8e8d", "hs":"#ab853c","ak":"#61b065"};


